import { getMeta } from '../utils/notification-helpers';
import NotificationIcon from '../NotificationIcon';
import { COMMENT_REACTION_ICONS } from '../../../Lexical/components/CommentsSidebar/components/CommentReactionButtons';

const LikeArticleNotification = ({ notification }) => {
  const meta = getMeta(notification);

  const reactionObj = COMMENT_REACTION_ICONS.find((r) => r.type === meta.reactionType);
  const reactionLabel = reactionObj?.textDisplay || meta.reactionType || 'reaction';
  const reactionSubIcon = reactionObj?.icon;

  return (
    <div className="flex items-start gap-2">
      <NotificationIcon avatarSrc={meta.avatar} subIcon={reactionSubIcon} />
      <div className="ml-2 min-w-0 w-[85%]">
        <p className="text-sm text-growth-green-900">
          <span className="font-bold">
            {meta.firstName} {meta.lastName}
          </span>
          <span> reacted with</span>{' '}
          <span className="font-extrabold text-growth-green">{reactionLabel}</span>
          <span> to your</span> <span className="font-extrabold text-growth-green">article</span>
        </p>

        {meta.articleTitle && (
          <p className="text-sm text-gray-600 mb-2">on "{meta.articleTitle}"</p>
        )}
      </div>
    </div>
  );
};

export default LikeArticleNotification;
